export const OWNER_JARVIS_REASON_CODE = Object.freeze({
  OVERDUE: "overdue",
  DEADLINE_TODAY: "deadline_today",
  FOLLOWUP_DUE: "followup_due",
  BLOCKS_PROJECT: "blocks_project",
  WAITING_EXPIRED: "waiting_expired",
  SCHEDULED: "scheduled",
  ECONOMIC_ATTENTION: "economic_attention",
  ROUTINE_DUE: "routine_due",
  SHORT_FIT: "short_fit",
  PROJECT_REVIEW_DUE: "project_review_due",
});

function asPositiveNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : null;
}

export function ownerJarvisReasonPhrase(reason) {
  const code = String(reason?.code || "").trim();
  const evidence = reason?.evidence || {};
  switch (code) {
    case OWNER_JARVIS_REASON_CODE.OVERDUE:
      return "ya venció";
    case OWNER_JARVIS_REASON_CODE.DEADLINE_TODAY:
      return "vence hoy";
    case OWNER_JARVIS_REASON_CODE.FOLLOWUP_DUE:
      return "hay un seguimiento que corresponde atender";
    case OWNER_JARVIS_REASON_CODE.BLOCKS_PROJECT:
      return "está bloqueando un proyecto";
    case OWNER_JARVIS_REASON_CODE.WAITING_EXPIRED:
      return "la espera llegó a su fecha de revisión";
    case OWNER_JARVIS_REASON_CODE.SCHEDULED:
      return "ya está programado";
    case OWNER_JARVIS_REASON_CODE.ECONOMIC_ATTENTION:
      return "hay dinero real que requiere atención";
    case OWNER_JARVIS_REASON_CODE.ROUTINE_DUE:
      return "es una rutina pendiente de hoy";
    case OWNER_JARVIS_REASON_CODE.PROJECT_REVIEW_DUE:
      return "el proyecto ya requiere su revisión";
    case OWNER_JARVIS_REASON_CODE.SHORT_FIT: {
      const estimated = asPositiveNumber(evidence.estimatedMinutes);
      const free = asPositiveNumber(evidence.freeMinutes);
      if (!estimated || !free || estimated > free) return "";
      return `entra en los ${Math.round(free)} minutos libres con ${Math.round(estimated)} minutos estimados`;
    }
    default:
      return "";
  }
}

export function explainOwnerJarvisReasons(reasons, { max = 2 } = {}) {
  const rows = Array.isArray(reasons) ? reasons : [];
  const codes = new Set(rows.map((reason) => String(reason?.code || "").trim()));
  const phrases = [];
  for (const reason of rows) {
    const code = String(reason?.code || "").trim();
    if (codes.has(OWNER_JARVIS_REASON_CODE.OVERDUE) && [OWNER_JARVIS_REASON_CODE.DEADLINE_TODAY, OWNER_JARVIS_REASON_CODE.SCHEDULED].includes(code)) continue;
    const phrase = ownerJarvisReasonPhrase(reason);
    if (!phrase || phrases.includes(phrase)) continue;
    phrases.push(phrase);
    if (phrases.length >= max) break;
  }
  if (!phrases.length) return "";
  return `Porque ${phrases.join(" y ")}.`;
}
